export default __webpack_public_path__ + "static/media/kml-file.a3dcc094.svg";